import MarketSimulationInfo from './MarketSimulationInfo';
import { usePricingRights } from '@util/PricingRightsHook';
import React from 'react';
import Utilities from '@util/Utilities';
import MarketStateDailySnapshotWithComparisonOutput
	from '@app/model/market_state/output/MarketStateDailySnapshotWithComparisonOutput';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import {
	RecommendationLimitTag,
	RecommendationLimitTooltip,
	useRecommendationLimit,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/recommmendation/RecommendationLimitExplanation';


const MarketStateSnapshotCalendarDayPriceRecommendationTableRow: React.FunctionComponent<{
	marketStateForStatDate: MarketStateDailySnapshotWithComparisonOutput
}> = ({ marketStateForStatDate }) => {

	const { companyHotel } = useSelectedCompanyHotel();
	const { canViewRecommendations, canChangePrices } = usePricingRights(companyHotel);
	const recommendationStateSnapshot = marketStateForStatDate?.priceRecommendationStateSnapshot;
	// The Limit Explanation of a Limited Recommendation: the amber tag and its hover card.
	const limitView = useRecommendationLimit(recommendationStateSnapshot?.recommendation);
	// One id per row instance: the desktop table and the mobile table both render this row for the same
	// day, and a shared id would position the card against the hidden anchor.
	const tooltipId = `price-limit-tooltip-${React.useId()}`;

	if (recommendationStateSnapshot === undefined || !recommendationStateSnapshot.hasValidRecommendation()) return null;

	const changePercent = Utilities.roundDouble(recommendationStateSnapshot.recommendation.effectiveChangeRate * 100, 0);

	return <tr className={changePercent < 0 ? 'bg-red-50' : 'bg-green-50'}>
		<td className="py-3 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">
			<span className="inline-flex items-center gap-x-1 whitespace-nowrap">Recommendation Price<MarketSimulationInfo /></span>
		</td>
		<td className="py-3 px-3 text-xs text-gray-500">
			<div className="inline-flex items-center gap-x-1.5">
				<span>{Utilities.formatAmount(recommendationStateSnapshot.recommendedPrice, companyHotel.settings.main.currency, 0)}</span>
				<span
					className="text-xs italic">({recommendationStateSnapshot.recommendation.effectiveChangeRate > 0 ? '+' : ''}{changePercent}%)</span>
				{limitView?.limited && <>
					<RecommendationLimitTag view={limitView} short tooltipId={tooltipId} extraClassName="whitespace-nowrap" />
					<RecommendationLimitTooltip id={tooltipId} view={limitView} />
				</>}
			</div>
		</td>
		<td className="py-3 px-0" colSpan={4} />
		<td
			className="py-3 px-3 text-xs text-gray-500">{Utilities.snakeCaseToWords(recommendationStateSnapshot.recommendation.roomMappingType)}</td>
		<td className="py-3 px-3 text-xs text-gray-500"
			colSpan={canViewRecommendations || canChangePrices ? 2 : 1} />
	</tr>;
};


export default MarketStateSnapshotCalendarDayPriceRecommendationTableRow;
